import React, { PureComponent } from 'react';
import { array, string, func, bool } from 'prop-types';
import { format } from 'util';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import Autocomplete from 'react-autocomplete';

class OccupationAutocomplete extends PureComponent {
    static propTypes = {
        occupations: array.isRequired,
        placeholder: string.isRequired,
        noResultsMessage: string.isRequired,
        countTemplate: string.isRequired,
        onSelect: func.isRequired,
        disabled: bool,
    };

    static defaultProps = {
        disabled: false,
    };

    state = {
        value: '',
    };

    static filterSuggestions(occupations, term) {
        const matcher = new RegExp(term, 'i');
        return occupations.filter(
            (o) => matcher.test(o.general) || matcher.test(o.specialization)
        );
    }

    static highlightMatch(text, value) {
        const index = text.toLowerCase().indexOf(value.toLowerCase());
        return value && index > -1 ? (
            <span>
                {text.substr(0, index)}
                <b>{text.substr(index, value.length)}</b>
                {text.substr(index + value.length)}
            </span>
        ) : (
            text
        );
    }

    static getItemValue(occupation) {
        return `${occupation.general} / ${occupation.specialization}`;
    }

    handleSelect = (value, occupation) => {
        this.props.onSelect(occupation);
        this.setState({ value: '' });
    };

    handleChange = (event) => {
        const { value } = event.currentTarget;
        this.setState({ value });
    };

    renderMenu = (items, value) =>
        items.length ? (
            <div className="suggestion-dropdown">
                <h2
                    className="u-screen-reader-only dropdown-status"
                    role="status"
                >
                    {format(this.props.countTemplate, items.length)}
                </h2>
                <ul>
                    {map(
                        groupBy(items, (item) => item.props['data-general']),
                        (specializations, general) => (
                            <li key={general}>
                                <h3 className="u-ma0 u-truncate">
                                    {OccupationAutocomplete.highlightMatch(
                                        general,
                                        value
                                    )}
                                </h3>
                                <ul role="presentation">{specializations}</ul>
                            </li>
                        )
                    )}
                </ul>
            </div>
        ) : (
            <div className="dropdown man pal centerify">
                {this.props.noResultsMessage}
            </div>
        );

    renderItem = (item, isHighlighted) => (
        <li
            aria-label={`${item.general}, ${item.specialization}`}
            className={`dropdown-item ${
                isHighlighted ? 'suggestion-dropdown__item--selected' : ''
            }`}
            data-general={item.general}
            key={item.id}
            role="option"
        >
            {OccupationAutocomplete.highlightMatch(
                item.specialization,
                this.state.value
            )}
        </li>
    );

    render() {
        const { value } = this.state;
        const { occupations, placeholder, disabled } = this.props;
        return (
            <Autocomplete
                getItemValue={OccupationAutocomplete.getItemValue}
                inputProps={{
                    placeholder,
                    disabled,
                }}
                items={OccupationAutocomplete.filterSuggestions(
                    occupations,
                    value
                )}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                renderItem={this.renderItem}
                renderMenu={this.renderMenu}
                value={value}
                wrapperStyle={{ display: 'block', position: 'relative' }}
            />
        );
    }
}

export default OccupationAutocomplete;
